export const api = {
  // 获取摄像机组数据
  querydeviceByArea: '/vas/bayonet/querydeviceByArea.json'
  // querydeviceByArea:'/vas/vehicle/retrieval/querydeviceByArea.json'
}